import { useLayoutEffect } from 'react';

import dataplus from '@lcsc/data-plus';
import { message, ConfigProvider } from 'antd';
import 'moment/locale/zh-cn';
import locale from 'antd/es/locale/zh_CN';

import { pathDataPolyfill } from '@/lib/path-data-polyfill';
import { env } from '@/utils/baseUrl';
import '@/utils/compliant';

import '../styles/ant-reset.less';
import '../styles/globals.css';

const MyNextApp = ({ Component, pageProps }) => {
  useLayoutEffect(() => {
    try {
      pathDataPolyfill();
      dataPlusInit();
    } catch (err) {
      console.error(err);
    }
    message.config({
      top: 400,
      duration: 3,
      maxCount: 5,
    });
  }, []);

  // 监控sdk开关
  function dataPlusInit() {
    // 初始化埋点
    if (typeof window !== 'undefined') {
      let dataplus_url = 'https://collector.szlcsc.com';
      if (['fat', 'dev', 'uat'].includes(env)) {
        dataplus_url = `https://${env}collector.szlcsc.com`;
      } else if (['local'].includes(env)) {
        dataplus_url = `https://devcollector.szlcsc.com`;
      }
      dataplus?.init({
        c_url: `${dataplus_url}/collect.js`,
        pf: 'pc',
      });
    }
  }

  return (
    <ConfigProvider locale={locale} autoInsertSpaceInButton={false}>
      <Component {...pageProps} />
    </ConfigProvider>
  );
};

export default MyNextApp;
